import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Modal, Button } from "lib/components/index";

import { stateSelector, open, close, submit } from "./index";
import AddOrderTransferModalForm from "./AddOrderTransferModalForm";

@connect(
  (state) => ({
    transfer: stateSelector(state).transfer,
    opened: stateSelector(state).opened,
    submitLoading: stateSelector(state).submitLoading,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        open,
        close,
        submit,
      },
      dispatch
    )
)
export default class AddOrderTransferModal extends React.PureComponent {
  handleSave(newOrder) {
    const { close, onSave } = this.props;
    close();
    onSave(newOrder);
  }

  _getTitle() {
    const { transfer } = this.props;

    if (!transfer) {
      return I18n.t("papp.orders.AddOrderTransferModal.default_title");
    } else if (transfer.refund) {
      return I18n.t("papp.orders.AddOrderTransferModal.new_refund_title");
    } else {
      return I18n.t("papp.orders.AddOrderTransferModal.new_transfer_title");
    }
  }

  render() {
    const { opened, submitLoading, close, submit } = this.props;

    return (
      <Modal closeIcon closeOnDimmerClick={false} open={opened} onClose={close}>
        <Modal.Header>{this._getTitle()}</Modal.Header>
        <Modal.Content>
          <AddOrderTransferModalForm onSave={this.handleSave.bind(this)} />
        </Modal.Content>
        <Modal.Actions>
          <Button as="a" basic onClick={close} disabled={submitLoading} content={I18n.t("papp.common.cancel")} />
          <Button as="a" primary onClick={submit} disabled={submitLoading} content={I18n.t("papp.common.save")} />
        </Modal.Actions>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/orders/AddOrderTransferModal/AddOrderTransferModal.jsx